import * as React from 'react';
import { cn } from '@/lib/utils';

const ChatFile = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-file', 'mb-2 flex items-center gap-3 rounded-sm border border-solid border-neutral-lightest bg-white p-3 shadow-dropshadow-sm transition duration-150 hover:shadow-dropshadow-md', className)}
    {...props}
  />
));
ChatFile.displayName = 'ChatFile';

const ChatFileContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-chat-file-content', 'flex w-10 grow flex-col', className)}
    {...props}
  />
));
ChatFileContent.displayName = 'ChatFileContent';

const ChatFileTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-chat-file-title', 'mb-0 truncate text-sm font-bold text-primary-dark', className)}
    {...props}
  />
));
ChatFileTitle.displayName = 'ChatFileTitle';

const ChatFileMeta = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-chat-file-meta', 'mb-0 truncate text-xs text-neutral', className)}
    {...props}
  />
));
ChatFileMeta.displayName = 'ChatFileMeta';

export { ChatFile, ChatFileContent, ChatFileTitle, ChatFileMeta };
